import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { RmRfidTagModel } from './rm-rfid-tag.model';

export class RmRfIdTagResponse extends GlobalResponseObject{
    data?: RmRfidTagModel;
    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data //RackDto
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: RmRfidTagModel) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}
 